import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20golden%20and%20deep%20red%20lighting%2C%20dramatic%20atmosphere%2C%20velvet%20curtains%2C%20film%20projector%20beam%2C%20artistic%20composition%2C%20rich%20contrast%2C%20luxurious%20vintage%20cinema%20style&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="麻花影视 - 高清影视在线观看平台"
        title="麻花影视 高清影视在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          麻花影视
        </h1>
        <p className="text-base md:text-xl text-white/80 max-w-2xl mb-8 leading-relaxed">
          汇集四虎影视、影视飓风、番茄影视、大叔影视、桃花影视等特色频道<br className="hidden sm:block" />
          高清不缓冲，满足您的每一种观影需求
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/sihu"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            立即观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border-2 border-white/60 text-white rounded-full text-base font-semibold hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}